import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from 'react-ga';
import { DISABLE_GA } from "@/core/variables";


export const useReactGA = () => {
    const location = useLocation(); 

    useEffect(() => {
        if (DISABLE_GA) {
            return;
        }
        ReactGA.pageview(`${window.location.hostname}${location.pathname}${location.search}`);
    }, [location]);
};
